import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate
} from "react-router-dom";

import { AuthProvider, useAuth } from "./context/AuthContext";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";

import Artists from "./components/artist/Artists";
import EditArtist from "./components/artist/EditArtist";
import AddArtist from "./components/artist/AddArtist";
import Bookings from "./components/artist/Bookings";

import Agents from "./components/agent/Agents";
import AddAgent from "./components/agent/AddAgent";
import EditAgent from "./components/agent/EditAgent";

import Users from "./components/users/Users";
import AddUser from "./components/users/AddUser";
import EditUser from "./components/users/EditUser";
import EditCustomerPassword from "./components/users/EditCustomerPassword";

import TopHeader from "./components/include/TopHeader";
import Sidebar from "./components/include/Sidebar";

import ProtectedRoute from "./components/ProtectedRoute";


const Layout = ({ children }) => {
    const { isLoggedIn } = useAuth();

    return (
        <>
            {isLoggedIn && <TopHeader />}
            {isLoggedIn && <Sidebar />}

            {children}
        </>
    );
};


function AppRoutes() {
    const { isLoggedIn } = useAuth();

    return (
        <Routes>

            {/* Login */}
            <Route
                path="/"
                element={
                    isLoggedIn
                        ? <Navigate to="/dashboard" />
                        : <Login />
                }
            />


            {/* Dashboard */}
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />


            {/* Artists */}
            <Route
                path="/artists"
                element={
                    <ProtectedRoute allowedRoles={["admin", "artist", "agent", "organization"]}>
                        <Artists />
                    </ProtectedRoute>
                }
            />


            {/* Add Artist */}
            <Route
                path="/artist/add"
                element={
                    <ProtectedRoute allowedRoles={["admin", "artist", "agent", "organization"]}>
                        <AddArtist />
                    </ProtectedRoute>
                }
            />


            {/* Edit Artist */}
            <Route
                path="/artist/edit/:id"
                element={
                    <ProtectedRoute allowedRoles={["admin", "artist", "agent", "organization"]}>
                        <EditArtist />
                    </ProtectedRoute>
                }
            />


            {/* Artist Bookings */}
            <Route
                path="/artist/bookings/:artistId"
                element={
                    <ProtectedRoute allowedRoles={["admin", "artist", "agent", "organization"]}>
                        <Bookings />
                    </ProtectedRoute>
                }
            />


            {/* Agents */}
            <Route
                path="/agents"
                element={
                    <ProtectedRoute allowedRoles={["admin", "agent", "organization"]}>
                        <Agents />
                    </ProtectedRoute>
                }
            />


            {/* Add Agent */}
            <Route
                path="/agent/add"
                element={
                    <ProtectedRoute allowedRoles={["admin", "agent", "organization"]}>
                        <AddAgent />
                    </ProtectedRoute>
                }
            />


            {/* Edit Agent */}
            <Route
                path="/agent/edit/:id"
                element={
                    <ProtectedRoute allowedRoles={["admin", "agent", "organization"]}>
                        <EditAgent />
                    </ProtectedRoute>
                }
            />


            {/* Users */}
            <Route
                path="/users"
                element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                        <Users />
                    </ProtectedRoute>
                }
            />


            {/* Add User */}
            <Route
                path="/user/add"
                element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                        <AddUser />
                    </ProtectedRoute>
                }
            />


            {/* Edit User */}
            <Route
                path="/user/edit/:id"
                element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                        <EditUser />
                    </ProtectedRoute>
                }
            />


            {/* Update Customer Password */}
            <Route
                path="/customer/updatepass/:id"
                element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                        <EditCustomerPassword />
                    </ProtectedRoute>
                }
            />

        </Routes>
    );
}


function App() {
    return (
        <AuthProvider>
            <Router>

                <Layout>
                    <AppRoutes />
                </Layout>

            </Router>
        </AuthProvider>
    );
}


export default App;